import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { isPartnerSite } from "utils";

const useChangeGlobalStyles = () => {
  const tenantSettings = useSelector((state) => state.tenant.settings);

  const location = useLocation();
  const lightBGRoutes = ["/privacy-policy", "/terms-and-conditions", "/contact-us", "/about-us", "/press", "/blogs"];
  useEffect(() => {
    if (!isPartnerSite() && lightBGRoutes.includes(location.pathname)) {
      document.documentElement.style.setProperty("--navbar-background-color", "#0000006e");
    }
  }, [location]);

  const cssVariablesToOverride = {
    primaryColor: "--primary-color",
    primaryColorLighten30: "--primary-color-lighten-30",
    secondaryColor: "--secondary-color",
    buttonTextColor: "--button-text-color",
    buttonBackgroundColor: "--button-background-color",
    navbarBackgroundColor: "--navbar-background-color",
    footerBackgroundColor: "--footer-background-color",
    primaryAccountBackgroundColor: "--primary-account-background",
  };

  const handleChangeStyles = () => {
    for (const key in cssVariablesToOverride) {
      if (Object.hasOwnProperty.call(cssVariablesToOverride, key)) {
        document.documentElement.style.setProperty(
          cssVariablesToOverride[key],
          tenantSettings?.styles[key],
        );
      }
    }

    document.documentElement.style.setProperty(
      cssVariablesToOverride.primaryColorLighten30,
      tenantSettings?.styles.primaryColor.concat("30"),
    );
  };

  return { handleChangeStyles, tenantSettings };
};

export const GetSiteConfigs = () => {
  const globalSettings = useChangeGlobalStyles();
  const { SiteConfigs } = (globalSettings && { ...globalSettings.tenantSettings }) || "";
  if (SiteConfigs.heroHeader === null) SiteConfigs.heroHeader = "Farm Link Program & Land Lease Company";
  if (SiteConfigs.heroSubHeader === null) SiteConfigs.heroSubHeader = `${window.location.host.split(".")[0]} farmland marketplace helps Landowners and Farmers cultivate the lessor/lessee relationship in a simple and transparent way.`;
  return SiteConfigs;
};

const ChangeGlobalStyles = ({ children }) => {
  const { handleChangeStyles } = useChangeGlobalStyles();
  useEffect(() => handleChangeStyles());

  return <>{children}</>;
};

export default ChangeGlobalStyles;
